import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=524cc351&scoped=true&"
import script from "./CalendarPage.vue?vue&type=script&lang=js&"
export * from "./CalendarPage.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPage.vue?vue&type=style&index=0&id=524cc351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524cc351",
  null
  
)

export default component.exports